require('./expensesByCategoryFilterApplied.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { Component } = require('react');
const Immutable = require('immutable');

// @ components
const { ClearAllFiltersButton } = require('commonsComponents/clearAllFiltersButton');
const { LabelFilterRange } = require('commonsComponents/labelFilterRange');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');

// @ commons
const { formatText, FormattedText } = require('core/i18n').i18n;
const { getLanguage } = require('core/i18n').i18n;

// @ helpers
const { countActiveFilters } = require('utilities/filtersHelper');

// @ constants
const { DATE_PICKER_CUSTOM_DATE_FORMAT, CLEAR_ALL_FILTERS_BUTTON_LABEL } = require('constants/commonsComponents');

class ExpensesByCategoryFilterApplied extends Component {

    buildDateFilterLabel() {
        const { immFilters, removeFilter } = this.props;
        const immFilterDate = immFilters.get('date');

        let labelFromDate = immFilterDate.get('from') ? immFilterDate.get('from').format(formatText(DATE_PICKER_CUSTOM_DATE_FORMAT)) : '';
        let labelToDate = immFilterDate.get('to') ? immFilterDate.get('to').format(formatText(DATE_PICKER_CUSTOM_DATE_FORMAT)) : '';

        if (labelFromDate && !labelToDate) {
            labelFromDate = `${ formatText('datePickerCustom-from') }: ${ labelFromDate }`;
        }

        if (!labelFromDate && labelToDate) {
            labelToDate = `${ formatText('datePickerCustom-to') }: ${ labelToDate }`;
        }

        return (
            <LabelFilterRange
                key="filter-date"
                from={labelFromDate}
                to={labelToDate}
                closeCallback={() => removeFilter('date')}
            />
        );
    }

    buildSubcategoryFilterLabel() {
        const { immFilters, removeFilter, category } = this.props;
        const subcategory = immFilters.getIn(['subcategory', 'subcategory']);
        return (
            <LabelFilterRange
                key="filter-subcategory"
                from={formatText(category + '-' + subcategory)}
                closeCallback={() => removeFilter('subcategory')}
            />
        );
    }

    buildContractsFilterLabel(immFilterContracts) {
        const label = ["debitContract", "creditContract", "allContracts"];
        if (immFilterContracts.get('value') !== '3') {
            return (
                <LabelFilterRange
                    key="filter-group-contract"
                    from={formatText(`groupContractFilter-${label[parseInt(immFilterContracts.get('value'))]}`)}
                />
            );
        } else {
            return '';
        }
    }

    buildAccountTypeFilterLabel(value) {
        return (
            <LabelFilterRange
                key="filter-type-account"
                from={formatText(`typeAccountFilter-${value === 'all' ? 'allAccounts' : 'customAccounts'}`)}
            />
        );
    }

    createButtonClearAllFilters() {
        const { immFilters, onClearFilter } = this.props;
        let amountContracts = 0;
        let response;

        if (immFilters.getIn(['contracts', 'isActive'])) {
            const accountsSelecteds = immFilters.getIn(['contracts', 'accountsContracts']).filter(filter => filter.get('selected')).size;
            const cardsSelecteds = immFilters.getIn(['contracts', 'cardsContracts']).filter(filter => filter.get('selected')).size;
            amountContracts = accountsSelecteds + cardsSelecteds;
        }

        const totalFilters = amountContracts + countActiveFilters([immFilters.get('date'), immFilters.get('subcategory')]);

        if (totalFilters > 1) {
            response = <ClearAllFiltersButton label={CLEAR_ALL_FILTERS_BUTTON_LABEL} onClick={onClearFilter} />;
        }

        return response;
    }

    getValueCurrency(value, currency) {
        const amountObject = Immutable.fromJS({
            amount: Math.abs(value),
            currency
        });
        return(amountObject);
    }

    render() {
        const { immFilters, totalMovementsCategory, totalExpensesCategory, currency } = this.props;
        const immFilterDate = immFilters.get('date');
        const immFilterSubcategory = immFilters.get('subcategory');
        const immFilterContracts = immFilters.get('groupContract');
        const immFilterTypeAccount = immFilters.getIn(['typeAccount', 'value']);
        const filterDateLabel = immFilterDate && immFilterDate.get('isActive') ? this.buildDateFilterLabel() : '';
        const filterSubcategoryLabel = immFilterSubcategory && immFilterSubcategory.get('isActive') ? this.buildSubcategoryFilterLabel() : '';
        const filterContracts = this.buildContractsFilterLabel(immFilterContracts);
        const filterAccountType = this.buildAccountTypeFilterLabel(immFilterTypeAccount);
        return (
            <div className="row expenses-by-category-filter-applied">
                <div className="col-xs-6 expenses-by-category-filter-applied__label">
                    {filterDateLabel}
                    {filterSubcategoryLabel}
                    {filterContracts}
                    {filterAccountType}
                </div>
                {totalMovementsCategory > 0 && <div className="col-xs-6 expenses-by-category-filter-applied__information">
                    <p className="count-expense"><FormattedText value="categoriesInfo-total"/><span>
                        <OneLineSymbolAmount
                            language={getLanguage()}
                            positiveAmount
                            amountObject={{amount: totalExpensesCategory, currencySymbol: currency}}
                            amountObjectFormatted={{currencySymbol: currency}}
                        />
                    </span></p>
                    <p className="count-movements">{totalMovementsCategory} <FormattedText value="categoriesInfo-movements"/></p>
                </div>}
            </div>
        );
    }
}

ExpensesByCategoryFilterApplied.propTypes = {
    immFilters: PropTypes.object.isRequired,
    totalMovementsCategory: PropTypes.number,
    totalExpensesCategory: PropTypes.number,
    currency: PropTypes.string,
    removeFilter: PropTypes.func,
    onClearFilter: PropTypes.func,
    category: PropTypes.string
}

module.exports = ExpensesByCategoryFilterApplied;
